import React from 'react';
import ResponsiveImage, { propTypes } from '../../../01_atoms/ResponsiveImage';

const ResponsiveHeroImage = (props) => <ResponsiveImage {...props} loading="preload" />;

export { propTypes };
export default ResponsiveHeroImage;
